var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcademicPlanStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 25,
    viewBox: "0 0 41 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.225098,
    y: 0.5,
    width: 40,
    height: 24,
    rx: 12,
    fill: "#474C5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.425 4.5H16.025C15.6007 4.5 15.1937 4.66857 14.8937 4.96863C14.5936 5.26869 14.425 5.67565 14.425 6.1V18.9C14.425 19.3243 14.5936 19.7313 14.8937 20.0314C15.1937 20.3314 15.6007 20.5 16.025 20.5H25.625C26.0494 20.5 26.4564 20.3314 26.7564 20.0314C27.0565 19.7313 27.225 19.3243 27.225 18.9V9.62304L22.425 4.5Z",
    fill: "#757A88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2688 4.87305V9.66533H26.8287",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2688 4.87305V9.66533H26.8287L22.2688 4.87305Z",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.025 13.2998H17.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.025 16.5H17.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.225 10.0996H18.425H17.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicPlanStep1);
export default __webpack_public_path__ + "static/media/academic_plan_step1.7c5358578cd6f50e880b5fa193629e30.svg";
export { ForwardRef as ReactComponent };